import React from 'react';
import { RectangleSkeleton, Flexbox } from '@morressier/ts';

const OpenCallsCardSkeletonLoader: React.FC<{}> = () => {
  const css = {
    border: '1px solid #d9dbdf',
    padding: '1rem',
    borderRadius: '1rem',
    marginBottom: '2rem',
    width: '100%'
  };

  return (
    <Flexbox flexWrap="wrap" flexDirection="column" style={css}>
      <RectangleSkeleton width="25%" height="1rem" className="mb1" />
      <RectangleSkeleton width="35%" height="1rem" className="mb1" />
      <RectangleSkeleton width="25%" height="1rem" className="mb1" />
      <RectangleSkeleton width="15%" height="1rem" className="mb1" />
    </Flexbox>
  );
};

export default OpenCallsCardSkeletonLoader;
